import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './layouts/Main'; // fallback for lazy pages
import { LanguageProvider } from './components/LanguageContext';
import LanguageRoute from './components/LanguageRoute';
import './static/css/main.scss'; // All of our styles

const { PUBLIC_URL } = process.env;

// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
const About = lazy(() => import('./pages/About'));
const ForRecruiters = lazy(() => import('./pages/ForRecruiters'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Resume = lazy(() => import('./pages/Resume'));

const App = () => (
  <LanguageProvider>
  <BrowserRouter
    basename={PUBLIC_URL}
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Suspense fallback={<Main />}>
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/about" element={<About />} />
        <Route path="/recruiters" element={<ForRecruiters />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/resume/:lang" element={<Resume />} />
        <Route path="/:lang" element={<LanguageRoute />}>
          <Route index element={<About />} />
          <Route path="about" element={<About />} />
          <Route path="recruiters" element={<ForRecruiters />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
  </LanguageProvider>
);

export default App;
